import { initStore } from '../../../common';
import { actions } from './actions';

export const permissionsStore = (): void => {
	const initialState = {
		slice: 'PERMISSIONS',
		userId: '',
		username: '',
		isActive: true,
		roles: [],
		activeRoles: [],
		customRole: false,
		permissionGroups: [],
		activePermissions: [],
		openedGroups: [],
		users: [],
		activeUsers: [],
		globalErrors: [],
		globalSuccess: '',
	};

	initStore(actions, initialState);
};
